import { render, staticRenderFns } from "./DeliveryReply.vue?vue&type=template&id=2fc5875a"
import script from "./DeliveryReply.vue?vue&type=script&lang=js"
export * from "./DeliveryReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports